module.exports = __webpack_public_path__ + "157bf097a6cf6317298e894b59789724.jpg";